import * as React from 'react';
const SvgCall = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={20}
        height={20}
        fill='none'
        {...props}>

        <g>
            <path
                fill='currentColor'
                d='M15.471 16.563a12.3 12.3 0 0 1-4.368-1.2 13.8 13.8 0 0 1-3.796-2.715 13.6 13.6 0 0 1-2.69-3.786 12.8 12.8 0 0 1-1.2-4.354.96.96 0 0 1 .256-.766.97.97 0 0 1 .744-.325h2.176q.378 0 .65.227.273.226.38.592l.436 1.743q.05.28-.03.545a.94.94 0 0 1-.265.433L5.84 8.831q.465.871 1.03 1.64.565.77 1.24 1.44a12.5 12.5 0 0 0 3.107 2.264l1.974-1.928a.86.86 0 0 1 .4-.243q.227-.061.505-.02l1.668.367q.379.105.599.385.22.281.22.667v2.16a.95.95 0 0 1-.335.744 1 1 0 0 1-.777.256'
            />
        </g>
    </svg>
);
export default SvgCall;
